<template>
  <div class="thumbnail-container">
    <img :src="img" :alt="altText" class="thumbnail-img">
  </div>
</template>

<script>
  export default {
    name:'Thumbnails',
    props: {
      img: {
        type: String,
      },
      // Añadimos un prop para el texto alternativo por accesibilidad
      altText: { 
        type: String,
        default: 'Imagen del vehículo' 
      }
    }
  }
</script>

<style scoped>
/* Dentro de Thumbnails.vue (Componente Hijo) */
.thumbnail-container {
  /* Se ajusta al 200x200 del padre (.image-popup-wrapper) */
  width: 100%;
  height: 100%;
  /* ...otros estilos... */
  display: flex;
  justify-content: center;
  align-items: center;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  /* Esto es clave: la imagen se ajustará al 200x200 sin ser recortada */
  object-fit: contain; 
  display: block; 
}
</style>